import { EmberRosterRole } from "game-common/models"
import { Graphics, Text } from "pixi.js"
import { TextRenderer } from "../text/text_renderer"
import { createWheelIcon, WheelIcon } from "./command_wheel_icons"

// Shared with world badges, roster cards, role choices and offscreen markers.
export const EMBER_ROLE_ICONS: Partial<Record<EmberRosterRole, WheelIcon>> = {
    lord: "crown",
    defender: "shield",
    forager: "axe",
}

export const EMBER_ROLE_COLORS: Partial<Record<EmberRosterRole, number>> = {
    lord: 0xffd078,
    defender: 0xff8a5c,
    forager: 0x7be08a,
}

// All glyphs are centred at the origin. Players and visitors retain their existing badges.
export const createEmberRoleGlyph = (role: EmberRosterRole | null, size: number, accent?: number): Graphics | Text => {
    const icon = role && EMBER_ROLE_ICONS[role]
    if (icon) return createWheelIcon(icon, size, accent ?? EMBER_ROLE_COLORS[role!] ?? 0xffffff)
    const glyph = new TextRenderer().fontSize(size).render(role === "player" ? "🧑" : role === "visitor" ? "🍗" : "•") as Text
    glyph.anchor.set(0.5)
    if (!role) glyph.tint = accent ?? 0xffffff
    return glyph
}
